import { apiGet, apiPost, apiPut, apiDelete } from '../fetch';

/**
 * Legacy API Endpoints (Deprecated)
 * ================================================================
 * Powered by Rails Web Application
 */
const endpointsDeprecated = {
  command: {
    apiPostConsultReschedule: (consultId, body = {}) =>
      apiPost(`/consults/${consultId}/reschedule/`, body),
    apiOrderQuestions: (formId, formQuestions) =>
      apiPost(`/forms/${formId}/questions/order`, {
        form_questions: formQuestions,
      }),
    apiAddQuestion: (formId, questionId) =>
      apiPost(`/forms/${formId}/questions/${questionId}/add`),
    apiDeleteQuestion: (formId, formQuestionId) =>
      apiDelete(`/forms/${formId}/questions/${formQuestionId}/remove`),
    apiSearchQuestions: (formId, search_q) =>
      apiGet(`/forms/${formId}/questions/search`, {
        search_q,
      }),
    createCoachingPair: (id, body = {}) =>
      apiPost(`/employees/${id}/coaching-pairs/new`, body),
    fetchCoachingPairs: (id, params = {}) =>
      apiGet(`/employees/${id}/coaching-pairs`, params),
  },
  submissions: {
    apiPostFormData: (submissionId, body = {}) =>
      apiPost(`/api/submissions/${submissionId}`, body),
  },
  pro: {
    apiGetCompletedEmployeeSessions: (employeeId) =>
      apiGet(`/pros/api/consults/completed/employees/${employeeId}`),
    apiGetConsult: (consultId) => apiGet(`/pros/api/consults/${consultId}`),
    apiPostConsultNoShow: (consultId) =>
      apiPost(`/pros/api/consults/${consultId}/mark-no-show`),
    apiPostConsultComplete: (consultId) =>
      apiPost(`/pros/api/consults/${consultId}/mark-complete`),
    apiGetConsults: (consultId) => apiGet('/pros/api/consults'),
    apiGetUpcomingConsults: (consultId) =>
      apiGet('/pros/api/consults/upcoming'),
    apiGetPastConsults: (consultId) => apiGet('/pros/api/consults/past'),
    apiGetUpcomingCheckIns: (consultId) =>
      apiGet('/pros/api/check-ins/upcoming'),
    apiGetSentCheckIns: (consultId) => apiGet('/pros/api/check-ins/sent'),
    apiSendVoipReminderEmail: (consultId) =>
      apiGet(`/pros/api/consults/${consultId}/email/reminder`),
    apiSendVoipSupportEmail: (consultId) =>
      apiGet(`/pros/api/consults/${consultId}/email/support`),
  },
  employee: {
    apiPutTimeZone: ({ timeZone }) =>
      apiPut('/api/account/time-zone', { timeZone }),
    apiPostActivate: (body) => apiPost('/activate', body),
    apiPostCountry: ({ countryCode, userId }) =>
      apiPost('/set-country', {
        countryCode,
        userId,
      }),
    apiPostConsults: (body) => apiPost('/api/consults', body),
    apiPostConsultCancel: () => apiPost('/api/consults/cancel'),
    apiPostConsultReschedule: (body) =>
      apiPost(`/api/consults/reschedule`, body),
    apiGetProAvailability: (params) => apiGet('/api/availability', params),
    apiPutProfile: (body) => apiPut('/api/account/profile', body),
  },
};

export default endpointsDeprecated;

/**
 * Expose API functions to window for
 * convenient development & debugging
 */
if (__DEVELOPMENT__) {
  window.BravelyApiDeprecated = endpointsDeprecated;
}
